// extracted by mini-css-extract-plugin
export default {"brief-live__container":"styles_brief-live__container__fQuNB"};